<template>
  <div v-if="!$page" />
  <div v-else class="page">
    <header class="header -column">
      <h1 v-reveal="{ delay: 550 }" class="header__subtitle">{{ $page.header.hat }}</h1>
      <HighlightedTitle
        v-reveal="{ delay: 600 }"
        :title="$page.header.title"
        class="header__title"
      />
      <RawHtml
        v-reveal="{ delay: 650 }"
        style="max-width: 769px"
        :html="$page.header.description"
      />
    </header>

    <section v-reveal="{ delay: 700 }" class="section -mobile-bleed">
      <GoogleMapFilters :labels="$page.labels" />
      <GoogleMapViewport :projects="projects" :labels="$page.labels" />
    </section>

    <CtaContactSection
      v-reveal="{ delay: 100 }"
      :title="$page.contact.title"
      :subtitle="$page.contact.description"
      :link-label="$page.contact.label"
      route-name="involve"
    />
  </div>
</template>

<script>
import RawHtml from '@/components/global/RawHtml.vue'
import GoogleMapFilters from '@/components/googleServices/GoogleMapFilters.vue'
import GoogleMapViewport from '@/components/googleServices/GoogleMapViewport.vue'
import HighlightedTitle from '@/components/partials/HighlightedTitle.vue'
import CtaContactSection from '@/components/sections/CtaContactSection.vue'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Projects',
  beetPage: 'projects',
  mixins: [PageMetaMixin],
  components: { RawHtml, CtaContactSection, HighlightedTitle, GoogleMapViewport, GoogleMapFilters },
  computed: {
    projects() {
      const { category, status } = this.$route.query
      if (!category && !status) return Object.values(this.$beet.projects)

      return Object.values(this.$beet.projects).filter((project) => {
        const matchesCategory = !category || project.category === category
        const matchesStatus = !status || project.status === status
        return matchesCategory && matchesStatus
      })
    },
  },
}
</script>
